import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioEmpresaDetalharComponent } from './usuario-empresa-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: UsuarioEmpresaDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class UsuarioEmpresaDetalharRoutingModule { }
